import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiCreateInvite(groupId) {
    try {
        const res = await fetch(`${API_URL}/groups/${groupId}/invites`, {
            method: "POST",
            headers: jsonHeaders()
        });
        return await res.json();
    } catch {
        return {error: "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez."};
    }
}

export async function apiGetInvite(token) {
    const res = await fetch(`${API_URL}/invites/${token}`);
    return res.json();
}

export async function apiJoinByInvite(token) {
    const res = await fetch(`${API_URL}/invites/${token}/join`, {
        method: "POST",
        headers: authHeaders()
    });
    return res.json();
}
